import WithRender from "../../templates/base/upload.html";
import { mapGetters, mapActions } from "vuex";
import ProgressBar from "vue-progressbar-component";

export default WithRender({
  components: {
    ProgressBar
  },
  computed: {
    ...mapGetters([
      "getShowUpload",
      "getSelectionId",
      "getShowPreviewInUpload",
      "getIsPackingEnabled",
      "getIsPreflighPitstop",
      "getPitstopFileIsLoading",
      "getPitstopFileStatusResponse",
      "getTimer",
      "getUrl",
      "getSelectedOption",
      "getUploadForProductPart",
      "getFileParameters"
    ])
  },
  methods: {
    ...mapActions([]),
    getAttribute: function (key) {
      return this.getUploadForProductPart(this.propsData.code)[key];
    }
  },
  props: ["propsData", "alwaysShow"]
});
